import { createSelector } from 'reselect';
import _take from 'lodash/take';
import {
  minOrderSumSelector,
  priceIncludingBonusesSelector,
  maxCashbackCanUseSelector,
} from '../pricing/selectors';

export { minOrderSumSelector, priceIncludingBonusesSelector, maxCashbackCanUseSelector };

// берем два последних заказа для истории заказов на главной
export const twoLastOrdersSelector = createSelector(
  state => state.order.list,
  list => _take(list, 2),
);

// вычисляем стоимость доставки
export const totalDeliveryCostSelector = createSelector(
  [
    priceIncludingBonusesSelector,
    state => state.order.checkout.currentRestaurant?.delivery_cost,
    state => state.order.checkout.currentRestaurant?.max_sum,
    minOrderSumSelector,
  ],
  (priceIncludingBonuses, delivery_cost = 0, max_sum = 0, minSum) => {
    return priceIncludingBonuses !== 0 &&
      delivery_cost > 0 &&
      priceIncludingBonuses >= minSum &&
      priceIncludingBonuses <= max_sum
      ? delivery_cost
      : 0;
  },
);

// перешагнули ли мы порог минимальной доставки
export const isOrderSumLowSelector = createSelector(
  [
    priceIncludingBonusesSelector,
    minOrderSumSelector,
    state => state.order.checkout.deliveryType,
    state => state.sailplay.usedBonuses,
  ],
  (priceIncludingBonuses, minSum, deliveryType, usedBonuses) => {
    if (deliveryType === 'pickup') {
      return false;
    }

    if (deliveryType === 'delivery') {
      return priceIncludingBonuses < minSum - usedBonuses;
    }

    return false;
  },
);

// это ненастоящий селектор
export const isOrderDoneSelector = orderData => {
  return orderData
    ? Number(orderData.order_status) === 6 ||
        (orderData.delivery_type === 'pickup'
          ? Number(orderData.order_status) === 3
          : Number(orderData.order_status) === 5)
    : false;
};

export const leftForFreeDeliverySelector = createSelector(
  [
    priceIncludingBonusesSelector,
    state => state.cart?.delivery_cost,
    state => state.order.checkout.currentRestaurant?.max_sum,
  ],
  (priceIncludingBonuses, delivery_cost = 0, max_sum = 0) => {
    const leftCartSum = max_sum - priceIncludingBonuses;
    return leftCartSum > 0 && !!delivery_cost ? leftCartSum : 0;
  },
);

// вычисляем зону доставки для того, чтобы прокинуть в методы, связанные с коризиной
export const getDeliveryAreaIdSelector = createSelector(
  [state => state.order.checkout.currentRestaurant, state => state.order.checkout.deliveryType],
  (currentRestaurant, deliveryType) => {
    return deliveryType === 'delivery' && currentRestaurant
      ? currentRestaurant.delivery_area_id
      : undefined;
  },
);
